import React, { Suspense, lazy, useState } from 'react';
import Button from '../../../../components/envago/Button/Button';
import Icon from '../../../../components/envago/Icon/Icon';
import { Trans, useTranslation } from 'react-i18next';
import './QRLogin.less';

// Loaded on demand: the scanner library and its WebAssembly decoder are only needed once the user opens the camera
const QRScannerOverlay = lazy(() => import('./QRScannerOverlay'));

const QRLogin = () => {
    const { t } = useTranslation();
    const [scannerVisible, setScannerVisible] = useState(false);

    return (
        <div className="qrlogin mt-4">
            <p>
                <Trans i18nKey={'login.qrcode.teaser.text'}>
                    Du hast einen QR-Code auf einer Ablesekarte oder in einem Brief erhalten? Und du hast eine Webcam?
                    <br />
                    Scanne jetzt einfach den QR-Code um schnell und einfach angemeldet zu werden:
                </Trans>
            </p>
            <Button className={'mt-4'} block={true} onClick={() => setScannerVisible(true)}>
                <>
                    <Icon path={Icon.Path.mdiQrcodeScan} className={'h-6 mr-2'} />
                    {t('login.qrcode.buttons.login')}
                </>
            </Button>

            <small>{t('login.qrcode.teaser.access')}</small>

            {scannerVisible && (
                <Suspense fallback={<div className="qr-scanner-overlay-placeholder" />}>
                    <QRScannerOverlay onClose={() => setScannerVisible(false)} />
                </Suspense>
            )}
        </div>
    );
};

export default QRLogin;
